import React, { useEffect, useState } from "react";
import time from "../../../assets/svg/time.svg";
import close from "../../../assets/svg/close.svg";
import DOMPurify from "dompurify";
import { createAutoSetupApi, createDockSetupApi, getDockGateApi, getTiggerApi, getUserApi, updateAutoSetupApi, updateDockSetupApi } from "../master-api";
import { Container, Row, Col } from "react-bootstrap";
import SearchWithAPI from "../../searchbox/searchbox.js";
import AsyncSelect from "react-select/async";
import { getDeptApi, getLocationApi } from "../customers/customer-api.js";
import CustomDropdownWithSearchStatic from "../../searchbox/searchWithStatic.js";
import moment from "moment/moment.js";
import loop from "../../../assets/svg/loop.svg";
import { ReactComponent as CrossIcon } from "../../../assets/svg/close.svg"
function AutoTriggerAdd({ triggerId, onSuccess, onClose }) {
    const [isClosing, setIsClosing] = useState(false);
    const [selectedMonthOption, setSelectedMonthOption] = useState("");
    const [dayOfMonth, setDayOfMonth] = useState(1);
    const [description, setDescription] = useState('');
    const [selectedDeptartment, setSelectedDeptartment] = useState([]);
    const [SaveselectedDept, SavesetSelectedDept] = useState([]);
    const [selectedDept, setSelectedDept] = useState([]);
    const [selectTime, setselectTime] = useState(() => {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    });

    const [selectposition, setselectposition] = useState('');
    const [selectpositionDay, setselectpositionDay] = useState('');
    const [reportSelect, setreportSelect] = useState([
        { 'label': 'Dock detailed report', value: 'Dock detailed report' },
        { 'label': 'Vehicle Queue & Dock Status Report', value: 'Vehicle Queue & Dock Status Report' }
    ]);
    const [selectedRepeatType, setRepeatType] = useState("daily");
    const handleChange = (e) => {
        setDescription(e.target.value);
    };
    // useEffect(() => {
    //     repeatPayloadObject()
    // }, [selectedRepeatType, selectedMonthOption, dayOfMonth,]);

    const handleDeptChange = (selectedOptions) => {
        console.log(selectedOptions);
        setSelectedDeptartment(selectedOptions);

    };
    const [repeatPayload, setRepeatPayload] = useState(null);
    // const repeatPayloadObject = () => {
    //     const payload = {
    //         start_date: document.getElementById("start_date").value,
    //         end_date: document.getElementById("end_date").value,
    //     };

    //     if (selectedRepeatType === "daily") {
    //         const dailyPayload = {

    //             day_of_week: [],
    //         };
    //         payload["recurrence_type"] = "daily";
    //         payload["repeat_on"] = dailyPayload;
    //     }

    //     if (selectedRepeatType === "weekly") {
    //         const dayMap = {
    //             Su: "sunday",
    //             M: "monday",
    //             Tu: "tuesday",
    //             W: "wednesday",
    //             Th: "thursday",
    //             F: "friday",
    //             Sa: "saturday",
    //         };

    //         const fullDays = selectedDay ? [dayMap[selectedDay]] : [];

    //         const weeklyPayload = {
    //             week_days_only: false,
    //             day_of_week: fullDays,
    //         };

    //         payload["recurrence_type"] = "weekly";
    //         payload["repeat_on"] = weeklyPayload;
    //     }

    //     if (selectedRepeatType === "monthly") {
    //         if (selectedMonthOption === "onDay") {
    //             const monthlyPayload = {
    //                 day_of_month: parseInt(dayOfMonth),
    //                 day: "",
    //                 position: "",
    //                 week_days_only: false,
    //                 day_of_week: [],
    //             };
    //             payload["recurrence_type"] = "monthly_fixed";
    //             payload["repeat_on"] = monthlyPayload;
    //         }

    //         if (selectedMonthOption === "position") {
    //             const position = document.getElementById("position").value;
    //             const day = document.getElementById("position_day").value;

    //             const monthlyPayload = {
    //                 day_of_month: "",
    //                 day: day,
    //                 position: position,
    //                 week_days_only: false,
    //                 day_of_week: [],
    //             };
    //             payload["recurrence_type"] = "monthly_relative";
    //             payload["repeat_on"] = monthlyPayload;
    //         }
    //     }

    //     setRepeatPayload(payload);
    // };
    const generateRepeatSummary = () => {
        const time = document.getElementById("from_time")?.value || "";

        if (!selectedRepeatType) return "";

        if (selectedRepeatType === "daily") {
            return `Repeat daily at ${convertTo12HourFormat(selectTime)}.`;
        }

        if (selectedRepeatType === "weekly") {
            const dayMap = {
                Sun: "Sunday",
                Mon: "Monday",
                Tue: "Tuesday",
                Wed: "Wednesday",
                Thu: "Thursday",
                Fri: "Friday",
                Sat: "Saturday",
            };

            const readableDay = dayMap[selectedDay] || selectedDay || "a selected day";
            return `Repeat weekly on ${readableDay} at ${convertTo12HourFormat(selectTime)}.`;
        }

        if (selectedRepeatType === "monthly") {
            if (selectedMonthOption === "onDay") {
                return `Repeat monthly on day ${dayOfMonth} at ${convertTo12HourFormat(selectTime)}..`;
            } else if (selectedMonthOption === "position") {

                return `Repeat monthly on the ${selectposition} ${selectpositionDay} at ${convertTo12HourFormat(selectTime)}. .`;
            }
        }

        return "";
    };


    function commonFormatDate(inputDate, formatString) {
        try {
            if (inputDate !== undefined) {
                /* // Parse the input date (MM/DD/YYYY format)
                const parsedDate = parse(inputDate, "MM/dd/yyyy", new Date());
        
                // Format the date
                return format(parsedDate, "EEEE, dd MMM yyyy");"dddd, DD MMM YYYY" */
                return moment(inputDate).format(formatString)
            } else {
                return "";
            }
        } catch (err) {
            console.error("Error fetching options:", err);
        } finally {
        }
    }
    const convertTo12HourFormat = (time) => {
        let [hours, minutes] = time.split(":");
        let period = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;
        return `${hours}:${minutes} ${period}`;
    };
    const repeatSentence = () => {
        if (repeatPayload.repeat?.recurrence_type === "daily") {
            if (repeatPayload.repeat.repeat_on.week_days_only === true) {
                return "The booking will repeat week days from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "."
            }
            return "The booking will repeat every " + repeatPayload.repeat.repeat + " day(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "."
        } else if (repeatPayload.repeat?.recurrence_type === "weekly") {
            return "The meeting will repeat every " + repeatPayload.repeat.repeat + " week(s) once from " + repeatPayload.repeat.repeat_on.day_of_week.join(",") + " from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else if (repeatPayload.repeat?.recurrence_type === "monthly_fixed") {
            return "The meeting will repeat on the " + repeatPayload.repeat.day_of_month + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else if (repeatPayload.repeat?.recurrence_type === "monthly_relative") {
            return "The meeting will repeat on the " + repeatPayload.repeat.repeat_on.position + " " + repeatPayload.repeat.repeat_on.day + " of every " + repeatPayload.repeat.repeat + " month(s) once from " + commonFormatDate(repeatPayload.repeat.start_date, "ddd DD MMM YYYY") + ", to " + commonFormatDate(repeatPayload.repeat.end_date, "ddd DD MMM YYYY") + ", between " + convertTo12HourFormat(repeatPayload.from) + " and " + convertTo12HourFormat(repeatPayload.to) + "";
        } else {
            return ""
        }
    }

    const [selectedDay, setSelectedDay] = useState(null); // use a single value instead of array

    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    const toggleDaySelection = (index) => {
        const day = days[index];
        setSelectedDay((prevSelected) => (prevSelected === day ? "" : day));
    };



    const getDepartmentData = (inputValue, callback) => {
        setTimeout(async () => {
            console.log("Fetching transport options with term:", inputValue);
            const response = await getDeptApi(inputValue);
            if (response.status === 200) {
                if (response.data.success === true) {
                    const options = response.data.suggestionlist.map((item) => ({
                        value: String(item.value),
                        label: String(item.label),
                    }));
                    callback(options);
                }
            }
        }, 1000);
    };


    const overlayStyle = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "stretch",
        zIndex: 1050,
        opacity: isClosing ? 0 : 1,
        transition: "opacity 0.3s ease-out",
    };

    const containerStyle = {
        padding: "24px",
        width: "100%",
        maxWidth: "550px",
        backgroundColor: "#fff",
        height: "100vh",
        overflowY: "auto",
        transform: isClosing ? "translateX(100%)" : "translateX(0)",
        transition: "transform 0.3s ease-out",
        animation: "slideInFromRight 0.3s forwards",
    };

    const labelStyle = {
        marginBottom: "6px",
        display: "block",
        fontFamily: "Epilogue",
        fontWeight: "500",
        fontSize: "13px",
        color: "#172B4D",
    };

    const inputStyle = {
        width: "100%",
        padding: "10px",
        borderRadius: "8px",
        height: "40px",
        border: "1px solid #E5E7EB",
        fontSize: "13px",
        fontFamily: "Epilogue",
        fontWeight: "400",
        outline: "none",
        color: "#8790A1",
    };

    const inlineFieldsStyle = {
        display: "flex",
        gap: "16px",
        marginBottom: "20px",
    };

    const timeInputWrapperStyle = {
        position: "relative",
    };

    const timeIconStyle = {
        position: "absolute",
        right: "13px",
        top: "50%",
        transform: "translateY(-50%)",
        width: "17px",
        height: "17px",
    };

    const textareaStyle = {
        width: "100%",
        padding: "10px",
        outline: "none",
        borderRadius: "8px",
        border: "1px solid #E5E7EB",
        fontSize: "14px",
        resize: "none",
        minHeight: "80px",
        color: "#8790A1",
    };

    const actionsStyle = {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        marginTop: "20px",
    };

    const styleTag = (
        <style>
            {`
        @keyframes slideInFromRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
      `}
        </style>
    );

    const apiUrl = process.env.REACT_APP_API_URL;
    const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
    const gateApiUrl = process.env.REACT_APP_GATE_API_URL;

    const [autoName, setautoName] = useState("");

    const [Reportoption, setReportoption] = useState(null);
    const [templateoption, settempalteoption] = useState(null);


    const [validations, setValidations] = useState({
        name: "",
        template_id: "",
        report: "",
        departments: "",
        recurrence_type: "",
        day_of_week: "",
        day_of_month: "",
        position: "",
        day: "",
        time: "",
        recurrence_value: "",
        cc_email: "",
        to_email: "",
    });
    const [emailList, setEmailList] = useState([]);
    const [email, setEmail] = useState("");
    const handleAddEmail = () => {
        const trimmedEmail = email.trim();

        // Simple email format regex
        const isValidEmail = (email) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!trimmedEmail) {
            setValidations((prev) => ({
                ...prev,
                to_email: "Email is required",
            }));
            return;
        }

        if (!isValidEmail(trimmedEmail)) {
            setValidations((prev) => ({
                ...prev,
                to_email: "Invalid email format",
            }));
            return;
        }

        // Clear validation if all is good
        setValidations((prev) => ({
            ...prev,
            to_email: "",
        }));
        setEmailList((prevList) => [...prevList, trimmedEmail]);

        // Add email logic here (e.g., pushing to a list, sending to backend, etc.)
        console.log("Email added:", trimmedEmail);

        // Optionally clear the input
        setEmail("");
    };
    const handleRemoveEmail = (indexToRemove) => {
        setEmailList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
    const [ccemailList, setccEmailList] = useState([]);
    const [ccemail, setccEmail] = useState("");
    const handleAddccEmail = () => {
        const trimmedEmail = ccemail.trim();

        // Simple email format regex
        const isValidEmail = (email) =>
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

        if (!trimmedEmail) {
            setValidations((prev) => ({
                ...prev,
                cc_email: "Email is required",
            }));
            return;
        }

        if (!isValidEmail(trimmedEmail)) {
            setValidations((prev) => ({
                ...prev,
                cc_email: "Invalid email format",
            }));
            return;
        }

        // Clear validation if all is good
        setValidations((prev) => ({
            ...prev,
            cc_email: "",
        }));
        setccEmailList((prevList) => [...prevList, trimmedEmail]);

        // Add email logic here (e.g., pushing to a list, sending to backend, etc.)
        console.log("Email added:", trimmedEmail);

        // Optionally clear the input
        setccEmail("");
    };
    const handleccRemoveEmail = (indexToRemove) => {
        setccEmailList((prevList) =>
            prevList.filter((_, index) => index !== indexToRemove)
        );
    };
    useEffect(() => {
        if (triggerId != null && triggerId !== "") {
            getDockEdit();
        }
    }, [triggerId]);
    const timeFromDateTime = (datetimeStr) => {
        const date = new Date(datetimeStr);
        return date.toTimeString().slice(0, 5); // "14:30"
    };


    const getDockEdit = async () => {
        try {

            const response = await getTiggerApi(triggerId);
            if (response.data.success === true) {
                const triggerMaster = response.data.trigger;
                setautoName(triggerMaster.name);
                setReportoption({ 'label': triggerMaster.report, value: triggerMaster.report })
                settempalteoption({ 'label': triggerMaster.template, value: triggerMaster.template_id })
                setSelectedDeptartment(triggerMaster.departments)
                const dayFullNamesMap = {
                    Sun: "sunday",
                    Mon: "monday",
                    Tue: "tuesday",
                    Wed: "wednesday",
                    Thu: "thursday",
                    Fri: "friday",
                    Sat: "saturday",
                };
                if (triggerMaster.recurrence_type === "monthly_relative") {
                    setSelectedMonthOption("position")
                    setselectposition(triggerMaster.recurrence_month_position)
                    setselectpositionDay(triggerMaster.recurrence_month_day)
                    setRepeatType("monthly")
                } else if (triggerMaster.recurrence_type === "monthly_fixed") {
                    setSelectedMonthOption("onDay")
                    setDayOfMonth(triggerMaster.recurrence_day_of_month)
                    setRepeatType("monthly")

                } else if (triggerMaster.recurrence_type === "weekly") {
                    setSelectedDay(dayFullNamesMap[triggerMaster.recurrence_day_of_week])
                    setRepeatType("weekly")
                }
                else if (triggerMaster.recurrence_type === "daily") {
                    setRepeatType("daily")
                }
                setselectTime(triggerMaster.recurrence_time)
                if (Array.isArray(triggerMaster.to_email)) {
                    setEmailList(triggerMaster.to_email)
                } else if (typeof triggerMaster.to_email === "string") {
                    setEmailList(triggerMaster.to_email.split(',')
                        .map(email => email.trim())
                        .filter(email => email !== ""));

                } else {
                    setEmailList([])
                }
                if (Array.isArray(triggerMaster.cc_email)) {
                    setccEmailList(triggerMaster.cc_email)
                } else if (typeof triggerMaster.cc_email === "string") {
                    setccEmailList(triggerMaster.cc_email.split(',')
                        .map(email => email.trim())
                        .filter(email => email !== ""));

                } else {
                    setccEmailList([])
                }


            }
            return response.data;
        } catch (err) {
            console.error("Error fetching category:", err);
        } finally {
        }
    };


    const handleReportDropdownChange = (option) => {
        console.log(option);
        setReportoption(option);
    };
    const handleTEmpalteDropdownChange = (option) => {
        console.log(option);
        settempalteoption(option);
    };

    const multiselectCustomStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            border: "0.7px solid #E5E5E5",
            padding: "2px",
            fontWeight: "500",
            fontSize: "13px",
            color: "#212129",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
            color: state.isSelected ? "#fff" : "#333",
            padding: 10,
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: "#F6F7F8",
            color: "#212129",
            borderRadius: "5px",
            padding: "2px 5px",
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: "#212129",
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: "#212129",
            cursor: "pointer",
            ":hover": {
                backgroundColor: "red",
                color: "white",
            },
        }),
    };

    const submitDockMaster = async () => {
        const dayFullNamesMap = {
            Sun: "sunday",
            Mon: "monday",
            Tue: "tuesday",
            Wed: "wednesday",
            Thu: "thursday",
            Fri: "friday",
            Sat: "saturday",
        };
        const dataBeforeSanitize = {
            "name": autoName,
            "template_id": templateoption?.value ?? ""
            ,
            "report": Reportoption?.value ?? "",
            "departments": selectedDeptartment.map(dept => dept.value),
            "recurrence_type": selectedRepeatType === "monthly" ? (selectedMonthOption === "onDay" ? 'monthly_fixed' : 'monthly_relative') : selectedRepeatType, // daily,weekly,monthly_fixed,monthly_relative
            "day_of_week": dayFullNamesMap[selectedDay], // sunday,monday,tuesday,wednesday,thursday,friday,saturday 
            "day_of_month": selectedMonthOption === "onDay" ? dayOfMonth : 0,
            "position": selectposition, // first,second,third,fourth,last
            "day": selectpositionDay, // sunday,monday,tuesday,wednesday,thursday,friday,saturday
            "time": selectTime,
            "recurrence_value": generateRepeatSummary(),
            "cc_email": ccemailList.join(','),
            "to_email": emailList.join(','),

        };
        const dataAfterSanitize = {};
        Object.entries(dataBeforeSanitize).forEach(([key, value]) => {
            if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
                dataAfterSanitize[key] = value;
            } else {
                dataAfterSanitize[key] = DOMPurify.sanitize(value);
            }
        });
        if (triggerId == null && triggerId !== "") {
            const response = await createAutoSetupApi(dataAfterSanitize);
            if (response.status === 200) {
                if (response.data.success === true) {
                    onSuccess(response.data);
                }
            }
            if (response.status === 400) {
                new Promise((resolve, reject) => {
                    const validationTemp = {
                        name: "",
                        template_id: "",
                        report: "",
                        departments: "",
                        recurrence_type: "",
                        day_of_week: "",
                        day_of_month: "",
                        position: "",
                        day: "",
                        time: "",
                        recurrence_value: "",
                        cc_email: "",
                        to_email: "",
                    };
                    Object.entries(response.data.error).forEach(([key, value]) => {
                        console.log(`${key}: ${value}`);
                        validationTemp[key] = value.length === 0 ? "" : value[0];
                    });
                    console.log("validationTemp...", validationTemp);
                    setValidations(validationTemp);
                });
            }
        } else {
            const response = await updateAutoSetupApi(triggerId, dataAfterSanitize);
            if (response.status === 200) {
                if (response.data.success === true) {
                    onSuccess(response.data);
                }
            }
            if (response.status === 400) {
                new Promise((resolve, reject) => {
                    const validationTemp = {
                        name: "",
                        template_id: "",
                        report: "",
                        departments: "",
                        recurrence_type: "",
                        day_of_week: "",
                        day_of_month: "",
                        position: "",
                        day: "",
                        time: "",
                        recurrence_value: "",
                    };
                    Object.entries(response.data.error).forEach(([key, value]) => {
                        console.log(`${key}: ${value}`);
                        validationTemp[key] = value.length === 0 ? "" : value[0];
                    });
                    console.log("validationTemp...", validationTemp);
                    setValidations(validationTemp);
                });
            }
        }
    };
    return (
        <div style={overlayStyle}>
            {styleTag}
            <div style={containerStyle}>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                    <h2 style={{ fontSize: "20px", fontWeight: "700", fontFamily: "Epilogue", color: "#172B4D" }}>{triggerId != null && triggerId !== "" ? "Edit" : "Add"} auto trigger</h2>
                    <button
                        style={{
                            background: "none",
                            border: "1px solid #D4DDE7",
                            borderRadius: "100px",
                            padding: "8px",
                            height: "40px",
                            width: "40px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        onClick={onClose} // Use the correct function to close the modal
                    >
                        <img src={close} alt="close" style={{ width: "14px", height: "14px" }} />
                    </button>
                </div>

                {/* Description */}
                <p
                    style={{
                        fontFamily: "Epilogue",
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#212129",
                        marginBottom: "20px",
                        borderBottom: "1px solid #E5E7EB",
                        paddingBottom: "20px",
                    }}>
                    Enter the details below to create a auto report trigger.
                </p>
                <Row className="px-0 mx-0">

                    <Col xs={12} sm={12} md={12} className="mt-1 px-0 ps-md-1">
                        <div className="field-title mb-1">
                            {" "}
                            Name<span style={{ color: "#FF4444" }}>*</span>{" "}
                        </div>
                        <input
                            type="text"
                            placeholder="Enter here"
                            className="input-field mt-1 w-100"
                            value={autoName}
                            onChange={(event) => {
                                setautoName(event.target.value); // Update state with input value
                            }}
                        />
                        <span className="field-error">{validations.name}</span>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="mt-1 px-0 ps-md-1">
                        <div className="field-title mb-1">
                            {" "}
                            Template<span style={{ color: "#FF4444" }}>*</span>{" "}
                        </div>
                        <SearchWithAPI onDropdownChange={handleTEmpalteDropdownChange} apiUrl={gateApiUrl + 'email_template/autosuggestion?medium=email'} placeholder={"Select Template"} selectedOption={templateoption} isSearch={false} />
                        <span className="field-error">{validations.template_id}</span>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="px-0 mt-1" >
                        <div className="field-title mt-1 px-0 ps-md-1 ">
                            To Email <span style={{ color: "#FF4444" }}>*</span>{" "}
                        </div>
                        <div className="input-group mt-2">
                            <input
                                type="text"
                                className="form-control input-field"
                                placeholder="Enter here"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />

                            <div
                                className="custom-btn"
                                type="button"
                                onClick={handleAddEmail}
                            >
                                Add
                            </div>


                        </div>


                        <span className="field-error">{validations.to_email}</span>
                        {emailList.length > 0 && (
                            <div className="field-title mt-2">Added To Emails</div>
                        )}

                        <div className="d-flex flex-wrap gap-2 mt-2">
                            {emailList.map((item, index) => (
                                <div
                                    key={index}
                                    className="d-flex align-items-center"
                                    style={{
                                        backgroundColor: "#f0f0f0",
                                        color: "#333",
                                        padding: "4px 10px",
                                        borderRadius: "16px",
                                        border: "1px solid #ddd",
                                        fontSize: "14px",
                                        lineHeight: "1"
                                    }}
                                >
                                    <span style={{ marginRight: "8px" }}>{item}</span>
                                    <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleRemoveEmail(index)}
                                    >
                                        <CrossIcon />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="px-0 mt-1" >
                        <div className="field-title mt-1 px-0 ps-md-1 ">
                            CC Email<span style={{ color: "#FF4444" }}>*</span>{" "}
                        </div>
                        <div className="input-group mt-2">
                            <input
                                type="text"
                                className="form-control input-field"
                                placeholder="Enter here"
                                value={ccemail}
                                onChange={(e) => setccEmail(e.target.value)}
                            />

                            <div
                                className="custom-btn"
                                type="button"
                                onClick={handleAddccEmail}
                            >
                                Add
                            </div>


                        </div>


                        <span className="field-error">{validations.cc_email}</span>
                        {ccemailList.length > 0 && (
                            <div className="field-title mt-2">Added CC Emails</div>
                        )}

                        <div className="d-flex flex-wrap gap-2 mt-2">
                            {ccemailList.map((item, index) => (
                                <div
                                    key={index}
                                    className="d-flex align-items-center"
                                    style={{
                                        backgroundColor: "#f0f0f0",
                                        color: "#333",
                                        padding: "4px 10px",
                                        borderRadius: "16px",
                                        border: "1px solid #ddd",
                                        fontSize: "14px",
                                        lineHeight: "1"
                                    }}
                                >
                                    <span style={{ marginRight: "8px" }}>{item}</span>
                                    <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleccRemoveEmail(index)}
                                    >
                                        <CrossIcon />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="mt-3 px-0 ps-md-1">
                        <div className="field-title mb-2">
                            {" "}
                            Report selection{" "}
                        </div>
                        <CustomDropdownWithSearchStatic onDropdownChange={handleReportDropdownChange} options={reportSelect} placeholder={"Select type"} selectedOption={Reportoption} isSearch={false} />
                        <span className="field-error">{validations.report}</span>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="mt-3 px-0 ps-md-1">
                        <div className="field-title mb-2">
                            {" "}
                            Department{" "}
                        </div>
                        <AsyncSelect isMulti cacheOptions value={selectedDeptartment} loadOptions={getDepartmentData} onChange={handleDeptChange} defaultOptions placeholder="Select Department" styles={multiselectCustomStyles} isClearable={false} />
                        <span className="field-error">{validations.departments}</span>
                    </Col>
                    <Col xs={12} sm={12} md={12} className="mt-3 px-0 ps-md-1">
                        <div className="field-title mb-2" style={{ fontWeight: '700', fontSize: '16px' }}>
                            {" "}
                            Trigger sequence{" "}
                        </div>
                        <select value={selectedRepeatType} style={{ width: '100%', border: '3px solid #FFE0E6', borderRadius: '10px', fontSize: '15px', fontWeight: '500', color: '#1E1E1E' }} className="px-2 py-2" onChange={(e) => setRepeatType(e.target.value)}>
                            <option value="daily">Repeat daily</option>
                            <option value="weekly">Repeat weekly</option>
                            <option value="monthly">Repeat monthly</option>
                        </select>
                        <span className="field-error">{validations.recurrence_type}</span>
                        {selectedRepeatType === "weekly" && (
                            <div className="d-flex flex-column mb-3" >
                                <div className="field-title mt-4 ">
                                    {" "}
                                    Week Days{" "}
                                </div>
                                <div className="d-flex align-items-center mt-2 " style={{ gap: "8px" }}>

                                    {days.map((day, index) => (
                                        <div
                                            key={index}
                                            onClick={() => toggleDaySelection(index)}
                                            style={{
                                                borderRadius: "100px",
                                                width: "40px",
                                                height: "40px",
                                                backgroundColor: selectedDay === day ? "#842234" : "#FFFFFF",
                                                color: selectedDay === day ? "#FFFFFF" : "#1E1E1E",

                                                border: "1px solid #E5E5E5",
                                                fontWeight: "500",
                                                fontSize: "14px",
                                                cursor: "pointer",
                                            }}
                                            className="px-3 py-3 d-flex justify-content-center align-items-center"
                                        >
                                            {day}
                                        </div>
                                    ))}
                                    <span className="field-error">{validations.day_of_week}</span>
                                </div>
                            </div>


                        )}
                        {selectedRepeatType === "monthly" && (
                            <div className="d-flex flex-column mb-2 mt-4" style={{ gap: '6px' }}>
                                <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                    <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                        <input type="radio" name="mon" value="onDay" checked={selectedMonthOption === "onDay"} onChange={(event) => { setSelectedMonthOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                        <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>On day</label>
                                    </div>

                                    <div className="mb-2">
                                        <input type="number" value={dayOfMonth} onChange={(event) => {

                                            console.log('event.target.value')
                                            console.log(event.target.value)
                                            setDayOfMonth(event.target.value);
                                        }} name="mi2" style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', width: '40px', height: '34px', border: 'none', textAlign: "center", fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} />
                                    </div>

                                    <div style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }} className="mb-2">
                                        day(s) once
                                    </div>

                                </div>

                                <div className="d-flex align-items-center mb-2" style={{ gap: '12px' }}>
                                    <div className="d-flex align-items-center" style={{ gap: '12px' }}>
                                        <input type="radio" name="mon" value="position" checked={selectedMonthOption === "position"} onChange={(event) => { setSelectedMonthOption(event.target.value); }} style={{ width: '18px', height: '18px' }} />
                                        <label style={{ fontWeight: '500', fontSize: '14.5px', color: '#1E1E1E' }}>On the</label>
                                    </div>

                                    <div>
                                        <select id="position" onChange={(e) => { setselectposition(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }} className="px-2 py-2" >
                                            <option value="">Select</option>
                                            <option value="first">First</option>
                                            <option value="second">Second</option>
                                            <option value="third">Third</option>
                                            <option value="fourth">Fourth</option>
                                            <option value="last">Last</option>
                                        </select>
                                    </div>

                                    <div >
                                        <select id="position_day" onChange={(e) => { setselectpositionDay(e.target.value) }} style={{ borderRadius: '12px', gap: '8px', backgroundColor: '#F5F5F5', border: 'none' }} className="px-2 py-2" >
                                            <option>Select</option>
                                            <option value="sunday">Sunday</option>
                                            <option value="monday">Monday</option>
                                            <option value="tuesday">Tuesday</option>
                                            <option value="wednesday">Wednesday</option>
                                            <option value="thursday">Thursday</option>
                                            <option value="friday">Friday</option>
                                            <option value="saturday">Saturday</option>
                                        </select>
                                    </div>

                                </div>


                                <span className="field-error">{validations.day_of_month}</span>
                                <span className="field-error">{validations.position}</span>
                                <span className="field-error">{validations.day}</span>


                            </div>
                        )}
                        <div className="d-flex flex-column mb-4" >
                            <div className="field-title mt-2 mb-2">
                                {" "}
                                Time{" "}
                            </div>
                            <div >


                                <input type="time" value={selectTime} onChange={(e) => setselectTime(e.target.value)}
                                    style={{ width: '100%', border: '1px solid #E5E5E5', borderRadius: '10px', fontWeight: '500', fontSize: '13px', color: '#1E1E1E' }} className="px-2 py-2" defaultValue={new Date().toTimeString().slice(0, 5)} />






                            </div>
                            <span className="field-error">{validations.time}</span>
                        </div>

                        <div className="px-3 py-3 d-flex align-items-center" style={{ borderRadius: '8px', backgroundColor: '#FFECF0', gap: '8px' }}>
                            <img src={loop} style={{ width: '16px', height: '16px' }} />
                            <div style={{ fontWeight: '500', fontSize: '14px', color: '#1E1E1E' }}>
                                {/* Repeats every 1 day */}{generateRepeatSummary()}
                            </div>

                        </div>
                    </Col>


                </Row>

                <div style={actionsStyle}>
                    <button
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #D1D5DB",
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "pointer",
                        }}
                        onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        onClick={submitDockMaster}
                        style={{
                            padding: "10px 20px",
                            backgroundColor: "#EF4444",
                            color: "#FFFFFF",
                            border: "none",
                            borderRadius: "12px",
                            fontWeight: "600",
                            fontSize: "14px",
                            cursor: "pointer",
                            fontFamily: "Epilogue",
                        }}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AutoTriggerAdd;
